import React, { useEffect } from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import FrontLoader from '../component/layout/FrontLoader'
import { formatDateTime, getDateTime } from '../utils/Helper'
import { useNavigate } from "react-router-dom";
import { LanguageConstants } from '../constants/LanguageConstants'

function HistoryModal(props:any) {
const quotationHistory = useMakeRequest()
const navigate = useNavigate()

useEffect(()=>{
  if(props){
    const payload ={
        quotation_id: props?.data?.quotation_id
    }
    quotationHistory.makeRequest({payload, url: ApiConstants?.QuotesAddresHistory, toastStatus: false })
  }
},[props])

    // naviagate to view-quotation page 
 const hanldeNaviagate =(e:any)=>{
        navigate(`/view-quotation/${e?.quotation_id}`)
    }
  return (
    <>
    {quotationHistory.loading ? <FrontLoader/> : null}
     <div className="modal fade com-modal modal view-history-modal show" id="viewHistoryModal" aria-labelledby="viewHistoryModalLabel" aria-hidden="false" style={{ display: 'block' }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewHistoryModalLabel">{LanguageConstants?.VIEW_HISTORY}</h5>
                            <button type="button" onClick={()=>props?.setHistoryshow(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 px-0">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>S. No</th>
                                            <th className="text-start">{LanguageConstants?.QUOTATIONID}</th>
                                            <th className="text-start">{LanguageConstants?.DATE}</th>
                                            <th className="text-start">{LanguageConstants?.TOTALSHIIPNGAMOUNT}</th>
                                            <th className="text-start">{LanguageConstants?.TOTALPRODUCTAMOUNT}</th>
                                            <th className="text-start">{LanguageConstants?.TOTAL}</th>
                                            <th className="text-start">{LanguageConstants?.STATUS}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quotationHistory?.data?.data?.map((res:any ,i:any)=>(
                                            <tr key={i} onClick={()=>hanldeNaviagate(res)} style={{cursor:'pointer'}} >
                                            <td className="text-center">{i+1}</td>
                                            <td>{res?.quotation_id}</td>
                                            <td>{formatDateTime(res?.created_at).formattedDate}</td>
                                            <td>${res?.total_shipping_price ? res?.total_shipping_price : 'N/A'}</td>
                                            <td>${res?.total_product_price ? res?.total_product_price : 'N/A'}</td>
                                            <td>${res?.total_amount ? res?.total_amount : 'N/A'}</td>
                                            <td className={res?.status == "2" ? "approved-text" : (res?.status == "0" || res?.status == "1")? "yellow-text" : "red-text"}>{res?.status == "1" ? `${LanguageConstants?.Progress}` : res?.status == "0" ? `${LanguageConstants?.PENDING}` : res?.status == "2" ? `${LanguageConstants?.APPROVED}` :`${LanguageConstants?.REJECT}`}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default HistoryModal